import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserActivityService } from '../../_services/user-activity.service';
import { AuthGaurdService } from '../../service/auth-gaurd.service';
import { AuthService } from '../../_services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.css']
})
export class SessionTimeoutComponent implements OnInit, OnDestroy {
  showWarning = false;
  showExpiredDialog = false;
  remainingTime = 0;

  private subscriptions: Subscription[] = [];
  private countdownTimer: any;

  constructor(
    private userActivityService: UserActivityService,
    private authGuardService: AuthGaurdService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Subscribe to session warning
    const warningSub = this.userActivityService.sessionWarning$.subscribe(show => {
      this.showWarning = show;
      if (show) this.startCountdown();
      else this.stopCountdown();
    });

    // Subscribe to session expired
    const expiredSub = this.userActivityService.sessionExpired$.subscribe(expired => {
      this.showExpiredDialog = expired;
      if (expired) {
        this.showWarning = false;
        this.stopCountdown();
        setTimeout(() => this.logout(), 30000); // Auto logout after 30s
      }
    });

    this.subscriptions.push(warningSub, expiredSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.stopCountdown();
  }

  /** Countdown timer for warning dialog */
  private startCountdown(): void {
    this.stopCountdown();
    this.countdownTimer = setInterval(() => {
      this.remainingTime = Math.ceil(this.userActivityService.getRemainingTime() / 1000);
      if (this.remainingTime <= 0) this.stopCountdown();
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }

  /** Extend session manually */
  extendSession(): void {
    this.userActivityService.extendSession();
    this.refreshToken();
    this.showWarning = false;
    this.stopCountdown();
  }

  /** Logout the user */
  logout(): void {
    this.authGuardService.logout();
  }

  /** Refresh authentication token */
  private refreshToken(): void {
    this.authService.login(this.authGuardService.loginNetworkId().toLowerCase(), "12345678")
      .subscribe(
        data => {
          this.authGuardService.saveToken(data.accessToken);
          this.authGuardService.saveUser(data);
          localStorage.removeItem('NOOOO');
        },
        (error: HttpErrorResponse) => this.authGuardService.logout()
      );
  }

  /** Format countdown time as mm:ss */
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2,'0')}`;
  }
}
